import CallToAction from "components/CallToAction"
import Testimonials from "components/DynamicComponent/molecules/Testimonials"
import richText from "utilities/richText"
import Wave from "public/assets/cta-banner.svg"
import { getStoryblokLink } from "utilities/getStoryblokLink"

export default function Content({ blok }) {
  return (
    <section className="lg:grid content-component-grid lg:max-w-screen-xl mx-auto pt-12 lg:py-12">
      <div className="content-component mb-12 lg:mb-0 lg:mr-24 lg:basis-2/3 px-8 lg:pl-8 lg:pr-0">
        <div className="content first:prose-headings:pt-0 first:prose-p:pt-0 prose-h2:text-m1 prose-h2:lg:text-m2 prose-h3:text-m1 prose-h3:font-bold prose-h3:font-secondary prose-p:py-2 prose-headings:py-3 prose-ul:list-disc prose-ul:pl-4 prose-ol:list-decimal prose-ol:pl-4 marker:text-gray-dark marker:text-sm xl:max-w-4xl prose-p:font-light prose-p:leading-7">
          {richText(blok.content)}
        </div>
      </div>
      <div className="lg:basis-1/3 content-cta-banner lg:pr-8">
        {blok?.cta_banner_heading || blok?.sidebar_content ? (
          <aside className="lg:sticky top-12">
            <Wave className="skinny-wave" />
            <div className="bg-navy -mt-1">
              <div className="flex flex-col justify-center items-center p-8 max-w-screen-xl mx-auto">
                {blok?.cta_banner_heading ? (
                  <h3 className="text-white font-medium text-m1 lg:text-m2 uppercase text-center">
                    {blok.cta_banner_heading}
                  </h3>
                ) : null}
                {blok?.sidebar_content ? (
                  <div className="text-center text-white prose-a:decoration-white prose-a:mx-auto prose-h4:text-base prose-h4:font-secondary prose-h4:font-bold prose-h4:pt-4 prose-h5:text-base  prose-a:pb-3">
                    {richText(blok.sidebar_content)}
                  </div>
                ) : null}
                {blok?.cta_banner_link && blok?.cta_button_label ? (
                  <CallToAction style="primary" href={getStoryblokLink(blok.cta_banner_link)} className="w-max mt-8">
                    {blok.cta_button_label}
                  </CallToAction>
                ) : null}
              </div>
            </div>
          </aside>
        ) : null}
      </div>
      {blok?.testimonials && blok.testimonials.length > 0 ? (
        <Testimonials
          blok={{
            testimonials: blok.testimonials,
            style: "light",
            title: "Success stories",
          }}
        />
      ) : null}
    </section>
  )
}
